import { useEffect } from 'react'
import { useLocation } from 'react-use'
import {
  useAuthHintQuery,
  useForceRegularLogin,
  useSsoEnabled,
} from '@global/hooks/queries/useAuthHintQuery'
import { useAppSelector } from '@redux/hooks'

/**
 * Used to handle SSO logic and redirect users to the SSO login page if they are not
 * logged in and the account is set to use SSO login.
 */
export const SsoGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const { user, bootstrapComplete } = useAppSelector(state => state.Auth)
  const loggedIn = !!user
  const { isInitialLoading } = useAuthHintQuery()
  const hasAccountSsoEnabled = useSsoEnabled()
  const forceRegularLogin = useForceRegularLogin()
  const isMfaRoute = location.pathname?.startsWith('/auth/mfa')

  /**
   * Removes /?login=system from the URL after successfuly logging in
   */
  useEffect(() => {
    if (loggedIn) {
      let urlWithoutLoginParam = window.location.href.replace('login=system&', '')
      urlWithoutLoginParam = urlWithoutLoginParam.replace('&login=system', '')
      urlWithoutLoginParam = urlWithoutLoginParam.replace('?login=system', '')
      window.history.replaceState({}, document.title, urlWithoutLoginParam)
    }
  }, [loggedIn])

  /**
   * Besides basic checks, we also check if bootstrap is complete,
   * this is needesd because the laravel token session
   * needs to be in sync with the react app.
   */
  const shouldStartSsoFlow =
    (!isMfaRoute &&
      !forceRegularLogin &&
      bootstrapComplete &&
      !loggedIn &&
      !isInitialLoading &&
      hasAccountSsoEnabled) ||
    queryParams.get('login') === 'sso'

  useEffect(() => {
    if (shouldStartSsoFlow) window.location.replace('/login')
  }, [shouldStartSsoFlow])

  return children
}
